import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "800",
  height: "800",
  viewBox: "0 0 33.88 33.88"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M30.414 10.031c.014.297.021.595.021.897 0 9.187-6.992 19.779-19.779 19.779A19.66 19.66 0 0 1-.001 27.584c.546.063 1.099.095 1.658.095 3.26 0 6.254-1.107 8.632-2.974a6.958 6.958 0 0 1-6.491-4.828c.424.082.858.125 1.308.125a6.89 6.89 0 0 0 1.83-.244 6.958 6.958 0 0 1-5.576-6.815v-.087c.939.521 2.01.833 3.15.869a6.95 6.95 0 0 1-3.091-5.787c0-1.274.343-2.467.94-3.495a19.733 19.733 0 0 0 14.327 7.263 7.056 7.056 0 0 1-.18-1.584 6.95 6.95 0 0 1 6.953-6.949 6.94 6.94 0 0 1 5.07 2.192 13.944 13.944 0 0 0 4.416-1.686 6.964 6.964 0 0 1-3.057 3.844 13.834 13.834 0 0 0 3.991-1.092 14.104 14.104 0 0 1-3.465 3.6z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }